export const Types = {
    START_LEAD_GEN_FIELD_PICK: "START_LEAD_GEN_FIELD_PICK",
    SUBMIT_LEAD_GEN_PICK: "SUBMIT_LEAD_GEN_PICK",
    END_LEAD_GEN_PICK: "END_LEAD_GEN_PICK"
};

export const startLeadGenFieldPickAction = (brk, leadGen, fieldPath, resourcePath) => ({
    type: Types.START_LEAD_GEN_FIELD_PICK,
    brk: brk,
    leadGen: leadGen,
    fieldPath: fieldPath,
    resourcePath: resourcePath
});

export const submitLeadGenPickAction = (fields) => ({
    type: Types.SUBMIT_LEAD_GEN_PICK,
    fields: fields
});

export const endLeadGenPickAction = () => ({
    type: Types.END_LEAD_GEN_PICK
});


// WEBPACK FOOTER //
// ./public/pages/LeadGenFieldPicker/actions.js